import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FC, PropsWithChildren } from 'react';
import { useNetworkContext } from '../../../offline/contexts/network/network.context';
import { offlineQueryClient } from '../../../offline/queryClient/offlineQueryClient';
import { queryClient } from './utils/queryClient';

const CustomQueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isOnline } = useNetworkContext();

  const isReactQueryDevtoolsEnabled = import.meta.env.VITE_ENABLE_REACT_QUERY_DEVTOOLS === 'true';

  return (
    <QueryClientProvider client={isOnline ? queryClient : offlineQueryClient}>
      {isReactQueryDevtoolsEnabled && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" position="right" />
      )}

      {children}
    </QueryClientProvider>
  );
};

export default CustomQueryClientProvider;
